/** État de l'aperçu d'une pièce : zoom, rotation par quarts de tour, page (PDF). Fonctions pures, sans effet de bord. */
export interface EtatVisionneuse {
  zoom: number;
  rotation: 0 | 90 | 180 | 270;
  page: number;
}

const PAS_ZOOM = 0.25;
const ZOOM_MIN = 0.5;
const ZOOM_MAX = 4;

export const etatInitial = (): EtatVisionneuse => ({ zoom: 1, rotation: 0, page: 1 });
export const zoomer = (e: EtatVisionneuse): EtatVisionneuse => ({ ...e, zoom: Math.min(ZOOM_MAX, e.zoom + PAS_ZOOM) });
export const dezoomer = (e: EtatVisionneuse): EtatVisionneuse => ({ ...e, zoom: Math.max(ZOOM_MIN, e.zoom - PAS_ZOOM) });

export function pivoter(e: EtatVisionneuse, sens: 'horaire' | 'antihoraire'): EtatVisionneuse {
  const rotation = ((e.rotation + (sens === 'horaire' ? 90 : 270)) % 360) as EtatVisionneuse['rotation'];
  return { ...e, rotation };
}

export const aller = (e: EtatVisionneuse, page: number, total: number): EtatVisionneuse => ({
  ...e,
  page: Math.min(Math.max(1, page), total),
});
export const reinitialiser = (e: EtatVisionneuse): EtatVisionneuse => ({ ...etatInitial(), page: e.page });
export const transformation = (e: EtatVisionneuse): string => `rotate(${e.rotation}deg) scale(${e.zoom})`;

/**
 * Marge de défilement, en % de la largeur : la part de la pièce qui déborde à gauche et en haut (agrandie autour de son centre,
 * ou tournée d'un quart de tour) reste atteignable au lieu de sortir de la zone en coordonnées négatives.
 */
export const margeDefilement = (e: EtatVisionneuse): number => Math.max(0, ((e.zoom - 1) / 2) * 100) + (e.rotation % 180 === 90 ? 25 : 0);
